import { render, staticRenderFns } from "./BotaoPdf.vue?vue&type=template&id=d48b4b92&"
import script from "./BotaoPdf.vue?vue&type=script&lang=js&"
export * from "./BotaoPdf.vue?vue&type=script&lang=js&"
import style0 from "./BotaoPdf.vue?vue&type=style&index=0&id=d48b4b92&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports